"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var config_1 = require("./config");
var commonProperties_1 = require("./lib/commonProperties");
var ReadingStats = /** @class */ (function () {
    function ReadingStats(getCookie, setCookie, baseUrl) {
        var _this = this;
        this._readingExtraFields = {};
        this.StartReading = function (page) {
            _this.Page = page;
            _this.Reading[page] = {
                Page: page,
                TimeWithoutZoom: 0,
                TimeWithZoom: 0,
                Zoom: false,
                InitTime: new Date().getTime()
            };
        };
        this.UpdateReadingTime = function (pageNum) {
            var currentTime = new Date().getTime();
            if (_this.Reading[pageNum].Zoom) {
                _this.Reading[pageNum].TimeWithZoom += (currentTime - _this.Reading[pageNum].InitTime);
            }
            else {
                _this.Reading[pageNum].TimeWithoutZoom += (currentTime - _this.Reading[pageNum].InitTime);
            }
        };
        this.ToggleZoom = function (pageNum) {
            _this.UpdateReadingTime(pageNum);
            _this.Reading[pageNum].Zoom = !_this.Reading[pageNum].Zoom;
            _this.Reading[pageNum].InitTime = new Date().getTime();
        };
        this.EndReading = function (catalogId, pageNum, doublePage, syncCall, endAction) {
            var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, SearchType = _a.SearchType, Integration = _a.Integration, View = _a.View, AdId = _a.AdId, OpeningHash = _a.OpeningHash, _b = _a.Provider, Provider = _b === void 0 ? "" : _b, VariantName = _a.VariantName, ModelName = _a.ModelName;
            _this.UpdateReadingTime(pageNum);
            var reading = _this.Reading[pageNum];
            var maxDecimals = 3;
            var data = __assign({ CatalogId: catalogId, PageNumber: pageNum, TimeWithZoom: _this._round((doublePage) ? ((reading.TimeWithZoom / 1000) / 2) : reading.TimeWithZoom / 1000, maxDecimals), TimeWithoutZoom: _this._round((doublePage) ? ((reading.TimeWithoutZoom / 1000) / 2) : reading.TimeWithoutZoom / 1000, maxDecimals), SearchWord: SearchWord,
                SearchCity: SearchCity,
                View: View,
                Provider: Provider,
                Origin: Origin,
                PageType: PageType,
                SearchType: SearchType,
                Platform: Platform,
                Integration: Integration,
                OpeningHash: OpeningHash,
                AdId: AdId,
                endAction: endAction,
                VariantName: VariantName,
                ModelName: ModelName }, _this._readingExtraFields);
            _this.CatalogReading(data, syncCall);
            if (doublePage) {
                var secondPageData = Object.assign({}, data);
                secondPageData.PageNumber += 1;
                _this.CatalogReading(secondPageData, syncCall);
            }
            _this.CleanPriorElement();
        };
        this.CleanPriorElement = function () { _this._readingExtraFields = {}; };
        this.SetPriorElement = function (_a) {
            var type = _a.type, id = _a.id;
            _this._readingExtraFields = {
                PriorElementType: type,
                PriorElementId: id
            };
        };
        this.CatalogReading = function (data, syncCall) {
            var payload = __assign(__assign({}, data), commonProperties_1.default(_this.$getCookie, _this.$setCookie));
            if (syncCall && navigator.sendBeacon) {
                navigator.sendBeacon(_this.BaseUrl + '/Catalog/ReadingPlain', JSON.stringify(payload));
                return;
            }
            else {
                axios_1.default.post(_this.BaseUrl + '/Catalog/Reading', payload);
            }
        };
        this._round = function (num, numberOfDecimals) { return (+(Math.round(+(num + "e+" + numberOfDecimals)) + "e-" + numberOfDecimals)); };
        this.BaseUrl = baseUrl;
        this.$getCookie = getCookie;
        this.$setCookie = setCookie;
        this.Page = -1;
        this.Reading = [];
    }
    return ReadingStats;
}());
exports.default = ReadingStats;
//# sourceMappingURL=reading.js.map